import { render, staticRenderFns } from "./SchoolTeamsHome.vue?vue&type=template&id=2846add9&scoped=true&"
import script from "./SchoolTeamsHome.vue?vue&type=script&lang=js&"
export * from "./SchoolTeamsHome.vue?vue&type=script&lang=js&"
import style0 from "./SchoolTeamsHome.vue?vue&type=style&index=0&id=2846add9&lang=less&scoped=true&"
import style1 from "./SchoolTeamsHome.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2846add9",
  null
  
)

export default component.exports